/** @jsx jsx */

import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

export type Background = 'white' | 'blue' | 'neutral' | 'checkered';

const backgroundColorStyles = {
  white: css({
    backgroundColor: token('elevation.surface'),
  }),

  blue: css({
    backgroundColor: token('color.background.brand.bold'),
  }),

  neutral: css({
    backgroundColor: token('color.background.neutral.hovered'),
  }),
  checkered: css({
    backgroundColor: 'var(--ds-surface, white)',
    backgroundImage: `
    linear-gradient(
      45deg,
      ${token('elevation.surface.sunken')} 25%,
      transparent 25%
    ),
    linear-gradient(
      135deg,
      ${token('elevation.surface.sunken')} 25%,
      transparent 25%
    ),
    linear-gradient(
      45deg,
      transparent 75%,
      ${token('elevation.surface.sunken')} 75%
    ),
    linear-gradient(
      135deg,
      transparent 75%,
      ${token('elevation.surface.sunken')} 75%
    );`,
  }),
};

export type ExampleShowcaseProps = {
  backgroundColor?: Background;
  children: React.ReactNode;
};

/**
 * __Example showcase__
 *
 * An example showcase displays an example with code and link to codesandbox.
 *
 */
const ExampleShowcase = ({
  backgroundColor = 'checkered',
  children,
}: ExampleShowcaseProps) => {
  return (
    <div
      role="group"
      css={[
        backgroundColorStyles[backgroundColor],
        css({
          padding: token('space.300', '24px'),
          backgroundPosition: '0 0, 10px 0, 10px -10px, 0px 10px',
          backgroundSize: '20px 20px',
          borderBlockEnd: `${token('border.width', '1px')} solid ${token(
            'color.border',
          )}`,
          borderRadius: `${token('border.radius', '3px')} ${token(
            'border.radius',
            '3px',
          )} 0 0`,
        }),
      ]}
    >
      {children}
    </div>
  );
};

export default ExampleShowcase;
